import React, { useEffect, useState } from 'react'
import { useParams, useRoutes } from 'react-router-dom'
import { api } from '../../app/Api/ApiSlice'
import { toast } from 'react-toastify'
import UserCard from '../../components/UserCard'
import Loader from '../../components/Loader'

const StoreFollowers = () => {
    const [storefollowers, setStorefollowers] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    const { name } = useParams()

    useEffect(() => {
        const getFollowers = async () => {
            try {
                setIsLoading(true)
                const response = await api.get(`/stores/${name}/followers`)
                setIsLoading(false)
                // console.log(response)
                if (response) {
                    setStorefollowers(response.data)
                }
            } catch (error) {
                setIsLoading(false)
                toast.error(error.response.data.message)
            }
        }

        getFollowers()
    }, [])
    return (
        <div className="shop-followers">
            <div className="followers-page-header">
                <h2 className="store-name">{name}</h2>
                <p className='page-title'>followers</p>
            </div>
            <div className="followers-list">
                {
                    storefollowers?.length >= 0 && storefollowers.map((follower) => (
                        <UserCard user={follower} />
                    ))
                }
            </div>
            {
                isLoading && <Loader />
            }
            {
                !isLoading && !storefollowers.length && <p className='not-found-msg'>No Followers found</p>
            }
        </div>
    )
}

export default StoreFollowers